var React = require('react');

function LogoMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15.36,7.67V16h4.11V7.67h3V4.35H19.38V3.93c0-.72.44-.91,1.57-.91a10.43,10.43,0,0,1,1.58.15V.25A15.65,15.65,0,0,0,19.88,0c-3,0-4.52,1.13-4.52,3.91v.45H13.91V7.67Z","key":0}),React.createElement("path",{"d":"M8.91,8.84c2.17.23,3.15,1.27,3.6,3.54L13.2,16H8.8l-.7-3.83c-.23-1.08-.63-1.39-1.86-1.39h-2V16H0V.49H8C11,.49,12.78,2,12.78,4.74v.08c0,2.39-1.52,3.77-3.87,3.91ZM6.52,7.15c1.29,0,2-.54,2-1.52V5.57c0-.94-.66-1.44-1.85-1.44H4.26v3Z","fillRule":"evenodd","key":1})]);
}

LogoMobile.defaultProps = {"width":"23","height":"16","viewBox":"0 0 23 16"};

module.exports = LogoMobile;

LogoMobile.default = LogoMobile;
